export function infiniteScroll() {

    const containers = document.querySelectorAll('[data-infinite-scroll]');

    if (!containers.length) return;

    const cleanups = [];
    containers.forEach(container => {

        const list = container.querySelector('[data-infinite-list]');
        const loader = container.querySelector('[data-infinite-loader]');
        const type = container.getAttribute('data-infinite-scroll');

        if (!list || !loader || !type || typeof hokraData === 'undefined') return;

        let currentPage = Number(container.getAttribute('data-current-page')) || 1;
        let maxPages = Number(container.getAttribute('data-max-pages')) || 1;
        let isLoading = false;
        const controller = new AbortController();

        async function loadMore() {

            if (isLoading || currentPage >= maxPages) return;

            isLoading = true;

            const formData = new FormData();

            formData.append('action', 'hokra_load_more_posts');
            formData.append('type', type);
            formData.append('page', currentPage + 1);
            formData.append('nonce', hokraData.infiniteScrollNonce);

            try {

                const response = await fetch(hokraData.ajaxUrl, {
                    method: 'POST',
                    body: formData,
                    credentials: 'same-origin',
                    signal: controller.signal
                });

                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }

                const result = await response.json();

                if (controller.signal.aborted) return;

                if (!result.success) {
                    throw new Error(result.data?.message || 'Ongeldig antwoord van de server');
                }

                const newItems = document.createRange().createContextualFragment(result.data.html);
                const addedElements = Array.from(newItems.children);
                const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

                if (!reduceMotion && typeof gsap !== 'undefined') {
                    gsap.set(addedElements, {
                        autoAlpha: 0,
                        y: 48,
                        scale: 0.98
                    });
                }

                list.append(newItems);

                currentPage = result.data.page;
                maxPages = result.data.max_pages;

                container.setAttribute('data-current-page', currentPage);
                container.setAttribute('data-max-pages', maxPages);

                container.dispatchEvent(new CustomEvent('infinite-scroll:loaded', {
                    bubbles: true,
                    detail: { elements: addedElements }
                }));

                if (!reduceMotion && typeof gsap !== 'undefined') {
                    gsap.to(addedElements, {
                        autoAlpha: 1,
                        y: 0,
                        scale: 1,
                        duration: 0.8,
                        stagger: 0.1,
                        ease: 'power4.out',
                        clearProps: 'opacity,visibility,transform',
                        onComplete: () => {
                            if (typeof ScrollTrigger !== 'undefined') {
                                ScrollTrigger.refresh();
                            }
                        }
                    });
                }

                if (!result.data.has_more) {
                    observer.disconnect();
                    loader.remove();
                }

                if (reduceMotion && typeof ScrollTrigger !== 'undefined') {
                    ScrollTrigger.refresh();
                }

            } catch (error) {

                if (error.name === 'AbortError') return;
                console.error('Items konden niet worden geladen:', error);

            } finally {

                isLoading = false;

            }
        }

        const observer = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) loadMore();
        }, {
            rootMargin: '500px 0px'
        });

        observer.observe(loader);
        cleanups.push(() => { controller.abort(); observer.disconnect(); });
    });
    return () => cleanups.forEach((cleanup) => cleanup());
}
